module.exports = __webpack_public_path__ + "static/media/icon_badges_not_found.30591fa4.svg";